<div class="container">
  <!-- <h1 class="main-title">Perfil</h1> -->
  <div class="menu">
    <div class="nav-button" [routerLink]="['information']" routerLinkActive="active">
      <p>Datos Personales</p>
      <img src="/assets/icons/person.svg" alt="personal-data" />
    </div>
    <div class="nav-button" [routerLink]="['accounts']" routerLinkActive="active">
      <p>Cuentas</p>
      <img src="/assets/icons/wallet.svg" alt="accounts" />
    </div>
    <div class="nav-button" [routerLink]="['documentation']" routerLinkActive="active">
      <p>Documentación</p>
      <img src="/assets/icons/document.svg" alt="document" />
    </div>
    <div
      *ngIf="!auth.loggedUser?.isCommerce"
      class="nav-button"
      [routerLink]="['arbitrage']"
      routerLinkActive="active"
    >
      <p>Arbitraje</p>
      <img src="/assets/icons/arbitrage.svg" alt="document" />
    </div>
    <div
      *ngIf="auth.loggedUser?.label === USER_LABEL.UNKNOWN_IDENTITY"
      class="nav-button"
      [routerLink]="['selfie']"
      routerLinkActive="active"
    >
      <p>Identidad</p>
      <img src="/assets/icons/arbitrage.svg" alt="document" />
    </div>
    <div
      *ngIf="!auth.loggedUser?.isCommerce"
      class="nav-button"
      [routerLink]="['commerce']"
      routerLinkActive="active"
    >
      <p>Commerce</p>
      <img src="/assets/icons/news/commerce-logo-white.svg" alt="document" />
    </div>
    <div class="nav-button" [routerLink]="['security']" routerLinkActive="active">
      <p>Seguridad</p>
      <img src="/assets/icons/lock.svg" alt="personal-data" />
    </div>
    <!-- <div class="nav-button" [routerLink]="['referral']" routerLinkActive="active">
      <p>Referidos</p>
      <img src="/assets/icons/referral-icon.svg" alt="personal-data" />
    </div> -->
    <!-- COMMING SOON -->
    <!-- <div class="button comming-soon disappear-mobile">
      <p>Referidos</p>
      <span>Muy pronto</span>
    </div> -->
  </div>

  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>
